import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    Template as ComparisonTableTemplate,
    exampleSlots,
} from "../../../components/comparison-table/comparison-table.templates";

const Template = () => html`
    <div class="ux-t-container-full">
        <div class="ux-row">
            <div class="ux-col ux-col-12 ux-col-sm-10 ux-u-offset-sm-1">
                ${ComparisonTableTemplate({
                    exampleSlot: Object.keys(exampleSlots)[1],
                    fullWidth: true,
                    stickyHeader: true,
                    stickyRowHeader: true,
                    variant: "data",
                })}
            </div>
        </div>
    </div>
`;

export default {
    title: "Website/Partial Templates/Technical Data Table",
    render: Template.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const Default = {};
